import React from 'react'
import IFrame from 'react-iframe'

import { translate, ui } from 'parking-react-common'

import Panel from '../components/Panel'
import { Column } from '../components/Grid'

const ChartsContainer = ({ t }) => (
    <Column size={ ui.SIZE.large } span={ 12 }>
        <Panel title={ t('Charts') }>
            { process.env.REACT_APP_FLAG_GRAFANA_URL && (
                <IFrame
                    url={ process.env.REACT_APP_FLAG_GRAFANA_URL }
                    width="100%"
                    height="1000px"
                    display="initial"
                    position="relative"
                />
            ) }
        </Panel>
    </Column>
)

export default translate()(ChartsContainer)
